export * from '../../../store';

export enum Fields {
  Module = 'workouts',
  WorkoutPlans = 'workout-plans',
  WorkoutTypes = 'workout-types',
  WorkoutIntervalOptions = 'workout-interval-options'
}

export interface WorkoutsState {
  [field: string]: any;
}

export const InitialState: WorkoutsState = {
  [Fields.WorkoutPlans]: null,
  [Fields.WorkoutTypes]: null,
  [Fields.WorkoutIntervalOptions]: null
};

export enum Types {
  UpdateState = 'update-workouts-state',
  GetWorkoutPlans = 'get-workout-plans',
  GetWorkoutTypes = 'get-workout-types',
  GetWorkoutIntervalOptions = 'get-workout-interval-options'
}

export interface UpdateState { type: Types.UpdateState; payload: any; }
export interface GetWorkoutPlans { type: Types.GetWorkoutPlans; }
export interface GetWorkoutTypes { type: Types.GetWorkoutTypes; }
export interface GetWorkoutIntervalOptions { type: Types.GetWorkoutTypes; }

export type ModuleAction = UpdateState;



// WEBPACK FOOTER //
// ./src/app/pages/workouts/store/workouts.model.ts